@file:UseContextualSerialization(LocalDate::class)

package pl.finn.forms.podpp

import io.kvision.types.LocalDate
import kotlinx.serialization.Serializable
import kotlinx.serialization.UseContextualSerialization
import pl.finn.forms.Zalacznik

@Serializable
data class PodppForm(
  var rodzaj: String? = null,
  var innyRodzaj: String? = null,
  var tytul: String? = null,
  var tresc: String? = null,
  var posiadaInformacjeDodatkowe: Boolean = false,
  var informacjeDodatkowe: ArrayList<InformacjaDodatkowa> = arrayListOf<InformacjaDodatkowa>(),
  var posiadaDoWiadomosci: Boolean = false,
  var doWiadomosci: ArrayList<Podmiot> = arrayListOf<Podmiot>()
)

@Serializable
data class PodppFormData(
  val form: PodppForm,
  val zalaczniki: List<Zalacznik>,
//  val podmiot: Podmiot, //todo podpp
  val url: String,
  val token: String?
)

//@Serializable
//data class Podmiot(
//  val id: Int,
//  val nazwa: String,
//  val miejscowosc: String?,
//  val miejscUrz: String?,
//  val telefon: String?,
//  val faks: String?,
//  val email: String?,
//  val www: String?,
//  val bip: String?,
//  val adresEsp: String?,
//  val adresEpuap: String?,
//  val wspolrzedneDeg: String?,
//  val wspolrzedneDms: String?,
//  val godzUrz: String?,
//  val ikonaUri: String?,
//  val params: String?,
//  val opis: String?,
//  val dedykowany: Boolean = false
//)

@Serializable
data class Podmiot(
  var jestInstytucja: String? = null,
  var instytucja: Instytucja = Instytucja(),
  var osoba: Osoba = Osoba()
)
@Serializable
data class Instytucja(
  var nazwaInstytucji: String? = null,
  var adres: Adres = Adres()
)

@Serializable
data class Osoba(
  var imie: String? = null,
  var imieDrugie: String? = null,
  var nazwiskoCzlonPierwszy: String? = null,
  var nazwiskoCzlonDrugi: String? = null,
  var nazwiskoCzlonTrzeci: String? = null,
  var adres: Adres = Adres()
)

@Serializable
data class Adres(
  var posiadaAdres: Boolean = false,
  var kodPocztowy: String? = null,
  var poczta: String? = null,
  var miejscowosc: String? = null,
  var ulica: String? = null,
  var budynek: String? = null,
  var lokal: String? = null,
)

@Serializable
data class InformacjaDodatkowa(
  var informacjaDodatkowa: String? = null
)
